/**
 * Contato de suporte humano — fallback do popup de indisponibilidade
 * quando ligar o servidor não resolve (instabilidade real). Gera um
 * link `wa.me` com mensagem pré-preenchida.
 */

const DEFAULT_WHATSAPP = '5534991530825'
const DEFAULT_NAME = 'Leandro'

export const SUPPORT_WHATSAPP =
  import.meta.env.VITE_SUPPORT_WHATSAPP ?? DEFAULT_WHATSAPP

export const SUPPORT_NAME = import.meta.env.VITE_SUPPORT_NAME ?? DEFAULT_NAME

export interface SupportMessageContext {
  userEmail?: string
}

/**
 * Mensagem pré-preenchida para o WhatsApp do suporte. Usada quando o
 * usuário já tentou ligar o servidor e mesmo assim não conseguiu acessar.
 */
export function buildSupportMessage(ctx: SupportMessageContext = {}): string {
  const emailLine = ctx.userEmail ? `\nMeu e-mail: ${ctx.userEmail}` : ''
  return (
    `Olá ${SUPPORT_NAME}! Tentei acessar o Optimus e o sistema segue ` +
    `indisponível mesmo depois de aguardar o servidor ligar. ` +
    `Pode me ajudar?${emailLine}`
  )
}

/**
 * Monta a URL do `wa.me` com a mensagem pré-preenchida. O número precisa
 * estar no formato internacional sem `+` (ex.: `5534991530825`).
 */
export function buildWhatsAppUrl(message: string): string {
  return `https://wa.me/${SUPPORT_WHATSAPP}?text=${encodeURIComponent(message)}`
}
